module.exports = __webpack_public_path__ + "img/DE00161.974f31a7.png";